import { render, staticRenderFns } from "./summary-project-progression-report.vue?vue&type=template&id=92945cc6&"
import script from "./summary-project-progression-report.vue?vue&type=script&lang=js&"
export * from "./summary-project-progression-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports